// extracted by mini-css-extract-plugin
export default {"nav":"nav_nav__u3A1g","active":"nav_active__Mu3XW","ar":"nav_ar__eMMAJ"};